module.exports = __webpack_public_path__ + "static/media/relaxMainImg.ec2a7499.svg";